try {
  if (meta.page.pageType == 'product'){
    let price = document.querySelector(".price__current > .money").textContent;
    let priceParent = document.querySelector(".price__current");
    
    const affirmProductObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        for (var i = 0; i < mutation.addedNodes.length; i++) {
          let textContent = mutation.addedNodes[i].textContent;
          // Check for the element that contains a price
          if (/[$]/g.test(textContent)) {
            let newPriceString = document.querySelector(".price__current > .money").textContent;
            // If price has changed, update Affirm ALA and reset price variable to ensure it has the most recent price
            if ((typeof affirm !== 'undefined') && price != newPriceString) {
              let numbersOnly = newPriceString.replace(/[^0-9]/g, "");
              let newPrice = parseFloat(numbersOnly);
              price = newPriceString;
              $('.affirm-as-low-as').attr('data-amount', newPrice);
              affirm.ui.refresh();
            }
          }
        }
      });
    });
    
    affirmProductObserver.observe(priceParent, { characterData: false, childList: true, attributes: false});
  } else if (meta.page.pageType == 'cart') {
    let price = document.querySelector(".cart-subtotal > .money").textContent;
    let priceParent = document.querySelector(".cart-subtotal");

    const affirmCartObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        for (var i = 0; i < mutation.addedNodes.length; i++) {
          let textContent = mutation.addedNodes[i].textContent;
          // Check for the element that contains a price
          if (/[$]/g.test(textContent)) {
            let newPriceString = document.querySelector(".cart-subtotal > .money").textContent;
            // If price has changed, update Affirm ALA and reset price variable to ensure it has the most recent price
            if ((typeof affirm !== 'undefined') && price != newPriceString) {
              let numbersOnly = newPriceString.replace(/[^0-9]/g, "");
              let newPrice = parseFloat(numbersOnly);
              price = newPriceString;
              $('.affirm-as-low-as').attr('data-amount', newPrice);
              affirm.ui.refresh();
            }
          }
        }
      });
    });
    
    affirmCartObserver.observe(priceParent, { characterData: false, childList: true, attributes: false, subtree: true});
  }
} catch (error) {}